import { AgTechTourConfig } from '@agtech/web/components/App/Tour/AgTechTourTypes'

export const AddPlanningTaskDialogTourConfig: AgTechTourConfig = {
    id: 'add-planning-task-dialog-tour',
    name: 'Add Task Tour',
    steps: [
        {
            targetId: 'add-task-name',
            title: 'Task Name',
            description: 'What needs to be done, for example Confirm the auctioneer and ring crew.',
            position: 'bottom',
        },
        {
            targetId: 'add-task-description',
            title: 'Description',
            description: 'Optional details to help whoever completes the task.',
            position: 'bottom',
        },
        {
            targetId: 'add-task-dates',
            title: 'Start and End Dates',
            description: 'When work on the task should begin and when it is due.',
            position: 'bottom',
        },
        {
            targetId: 'add-task-priority',
            title: 'Priority and Reminders',
            description: 'Set the priority and how many days should pass between reminder notifications.',
            position: 'bottom',
        },
        {
            targetId: 'add-task-assignee',
            title: 'Assigned To',
            description: 'Optionally assign the task to a member of your team so it appears in their My Tasks list.',
            position: 'top',
        },
    ]
}
